/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { useCustomer } from '@components/contexts/CustomerContext';
import { isManagerVar } from '@graphql/cache';
import { Stack, styled, Typography } from '@mui/material';
import { readFromCookies } from '@utils/cookies';
import { useTranslation } from 'next-i18next';
import React, { FC, useMemo } from 'react';

import { ProfileInfoSkeleton } from './SidebarProfileSkeletons';

import { StorageTokens } from '@/lib/constants';

const SidebarProfileInfoLabel = styled(Typography, {
  name: 'SidebarProfileInfo',
  slot: 'Label',
})(({ theme }) => ({
  fontSize: 10,
  fontWeight: 400,
  color: theme.palette.dark[700],
  maxWidth: theme.spacing(16.25),
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
}));

const SidebarProfileInfo: FC = () => {
  const { t } = useTranslation();
  const isManager = isManagerVar();
  const { customer, loading } = useCustomer();
  const { username } = customer || {};

  const groupName = useMemo(() => {
    return readFromCookies<string>(StorageTokens.SELECTED_GROUP_NAME);
  }, []);

  let profileInfoLabel = t('PROVEEDOR');
  if (isManager) {
    profileInfoLabel = `${t('RESPONSABLE')} - ${groupName}`;
  }

  if (loading) {
    return <ProfileInfoSkeleton />;
  }

  return (
    <Stack direction="column">
      <Typography component="span" variant="body2">
        {username}
      </Typography>

      <SidebarProfileInfoLabel variant="caption">{profileInfoLabel}</SidebarProfileInfoLabel>
    </Stack>
  );
};

export default SidebarProfileInfo;
